import { useContext, useRef, useState } from "react";
import {
  FaBookReader,
  FaChartArea,
  FaChartLine,
  FaMoneyBill,
  FaMoneyBillWaveAlt,
  FaMoneyCheck,
  FaRegMoneyBillAlt,
  FaStar,
  FaUserFriends,
  FaUserTie,
} from "react-icons/fa";

// api
import studentApi from "../../api/Student";
import classApi from "../../api/Classes";

//css
import "./Dashboard.css";

//components
import Card from "../../components/card/Card";
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import StatCard from "../../components/statcard/StatCard";
import AppCalendar from "../../components/calendar/AppCalendar";
import AppWrapper from "../../components/appWrapper/AppWrapper";

//data
import {
  empty,
  errorResponse,
  isArray,
  isObject,
  isString,
  prepareResponseData,
} from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import CompoundBarChart from "../../components/chart/compoundBarChart/CompoundBarChart";
import colors from "../../config/colors";
import EmptyList from "../../components/others/EmptyList";

const Dashboard = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const [value, onChange] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [isNoOfStudentLoading, setIsNoOfStudentLoading] = useState(false);
  const [totalFeesPaid, setTotalFeesPaid] = useState(0);
  const [fees, setFees] = useState(0);
  const [balanceOwed, setBalanceOwed] = useState(0);
  const [subjectsOffered, setSubjectsOffered] = useState([]);
  const [studentReports, setStudentReports] = useState([]);
  const [studentCurrentAssessmentRating, setStudentCurrentAssessmentRating] =
    useState(0);
  const [noOfSubjectsOffered, setNoOfSubjectsOffered] = useState(0);
  const [assessmentStat, setAssessmentStat] = useState({
    termData: 0,
    sessionData: 0,
  });

  const schoolData =
    !empty(user) && !empty(user.schoolData) ? user.schoolData : {};
  const schoolCurrency = !empty(schoolData.currency)
    ? schoolData.currency
    : "\u20A6";
  const classTitle =
    !empty(user) && !empty(user.classTitle) && isString(user.classTitle)
      ? user.classTitle
      : "";
  const authorizedSubjects =
    !empty(user) &&
    !empty(user.authorizedSubjects) &&
    isArray(user.authorizedSubjects)
      ? user.authorizedSubjects
      : [];

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const toastTR = useRef(null);

  useEffect(() => {
    getAssessmentStat();
    getStudentSubjects();
    getSessionTermlyAssessment();
    getStudentClassCurrentTermRating();
    // getSubjects();
  }, []);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  // const getTermAssessment = async () => {
  //   setIsNoOfStudentLoading(true);
  //   try {
  //     const schoolId =
  //       !empty(user) && !empty(user.schoolId) ? user.schoolId : "";
  //     const studentId = !empty(user) && !empty(user._id) ? user._id : "";
  //     const response = await studentApi.getTermAssessment(schoolId, studentId);
  //     const response_data = prepareResponseData(response);
  //     if (
  //       empty(response_data) ||
  //       empty(response_data.response) ||
  //       !response_data?.response
  //     ) {
  //       return;
  //     }
  //     const _assessmentData =
  //       !empty(response_data) && !empty(response_data.response)
  //         ? response_data.response
  //         : [];
  //     setChartData({
  //       labels: _assessmentData.map((data) => {
  //         const classTitle =
  //           !empty(data) && !empty(data.title) ? data.title : "";
  //         return classTitle;
  //       }),
  //       datasets: [
  //         {
  //           label: "Class Performance",
  //           data: _assessmentData.map((data) => {
  //             const sum = !empty(data) && !empty(data.sum) ? data.sum : 0;
  //             return sum;
  //           }),
  //           backgroundColor: _assessmentData.map((data) => {
  //             const sum = !empty(data) && !empty(data.sum) ? data.sum : 0;
  //             let colorCode = "#6d4dc7d6";
  //             if (sum < 50) {
  //               colorCode = colors.danger;
  //             }
  //             return colorCode;
  //           }),
  //           borderRadius: 12,
  //         },
  //       ],
  //     });
  //   } catch (error) {
  //     responseDialog("error", "Assessment Data", "Something went wrong.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const getAssessmentStat = async () => {
    setIsNoOfStudentLoading(true);
    try {
      const schoolId =
        !empty(user) && !empty(user.schoolId) ? user.schoolId : "";
      const studentId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getAssessmentStat(schoolId, studentId);
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.response) ||
        !response_data?.response
      ) {
        return;
      }
      const _assessmentData =
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : { termData: 0, sessionData: 0 };
      return setAssessmentStat(_assessmentData);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const getStudentClassCurrentTermRating = async () => {
    setIsNoOfStudentLoading(true);
    try {
      const schoolId =
        !empty(user) && !empty(user.schoolId) ? user.schoolId : "";
      const classId =
        !empty(user) && !empty(user.currentClassId) ? user.currentClassId : "";
      const studentId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getStudentClassCurrentTermRating(
        schoolId,
        studentId,
        classId
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.response) ||
        !response_data?.response
      ) {
        return;
      }
      const _assessmentData =
        !empty(response_data) &&
        !empty(response_data.response) &&
        parseInt(response_data.response)
          ? response_data.response
          : 0;
      return setStudentCurrentAssessmentRating(_assessmentData);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const getSessionTermlyAssessment = async () => {
    setIsNoOfStudentLoading(true);
    try {
      const schoolId =
        !empty(user) && !empty(user.schoolId) ? user.schoolId : "";
      const studentId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentApi.getSessionTermlyAssessment(
        schoolId,
        studentId
      );
      const response_data = prepareResponseData(response);
      if (
        empty(response_data) ||
        empty(response_data.response) ||
        !response_data?.response
      ) {
        return;
      }
      const _assessmentData =
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : {};
      const termScores =
        !empty(_assessmentData) &&
        !empty(_assessmentData.termScores) &&
        isObject(_assessmentData.termScores)
          ? _assessmentData.termScores
          : {};
      const studentReports =
        !empty(_assessmentData) &&
        !empty(_assessmentData.studentReports) &&
        isArray(_assessmentData.studentReports)
          ? _assessmentData.studentReports
          : [];
      setStudentReports(studentReports);
      const sessionsArr =
        !empty(_assessmentData) &&
        !empty(_assessmentData.sessionsArr) &&
        isArray(_assessmentData.sessionsArr)
          ? _assessmentData.sessionsArr.reverse()
          : [];
      let count = -1;
      // const colors = ["red", "blue", "green"];
      const chartColors = [colors.primary, colors.tomato, colors.orange];

      setChartData({
        labels: sessionsArr.map((data) => {
          return data;
        }),
        datasets: Object.entries(termScores).map(([value, data]) => {
          count++;
          return {
            type: "bar",
            label: value + "(%)",
            data: data,
            backgroundColor: chartColors[count],
          };
        }),
      });
      return;
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  // const getSubjects = async () => {
  //   try {
  //     const schoolId =
  //       !empty(user) && !empty(user.schoolId) ? user.schoolId : "";
  //     const response = await subjectApi.getSubjects(schoolId);
  //     const response_data = prepareResponseData(response);
  //     if (
  //       empty(response_data) ||
  //       empty(response_data.success) ||
  //       !response_data.success
  //     ) {
  //       return setReIndexedSubjects({});
  //     }
  //     const results =
  //       !empty(response_data) &&
  //       !empty(response_data.response) &&
  //       isArray(response_data.response)
  //         ? response_data.response
  //         : [];
  //     const _reIndexedSubjects = !empty(results) ? reIndex(results, "_id") : {};
  //     setReIndexedSubjects(_reIndexedSubjects);

  //     let assignedSubjects = [];
  //     const subjects = authorizedSubjects.map((data) => {
  //       const subjectIds =
  //         !empty(data) && !empty(data.subjectIds) && isArray(data.subjectIds)
  //           ? data.subjectIds
  //           : [];
  //       assignedSubjects = [...new Set([...assignedSubjects, ...subjectIds])];
  //     });
  //     setNoOfStaffAssignedSubjects(
  //       isArray(assignedSubjects) ? assignedSubjects.length : 0
  //     );
  //   } catch (error) {
  //     responseDialog("error", "Error Alert", "Failed to fetch subjects.");
  //   }
  // };

  const getStudentSubjects = async () => {
    try {
      const schoolId =
        !empty(user) && !empty(user.schoolId) ? user.schoolId : "";
      const classId = !empty(user.currentClassId) ? user.currentClassId : "";
      const response = await classApi.getSingleClass(classId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }
      const data =
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : {};
      const assignedSubjects =
        !empty(data) && !empty(data.subjects) && isArray(data.subjects)
          ? data.subjects.length
          : 0;
      setNoOfSubjectsOffered(assignedSubjects);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    }
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Hello, Welcome Back!" leftIcon="&#128075; " />
          {/* end menu header */}
          <div className="mt-10 dashboard_container">
            {/* left box */}
            <div id="main_left_box">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Subjects Offered"
                      entry={noOfSubjectsOffered}
                      icon={<FaUserTie className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Current Class"
                      entry={classTitle}
                      icon={<FaUserFriends className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Term Assessment"
                      entry={
                        !empty(assessmentStat) &&
                        !empty(assessmentStat.termData) &&
                        parseFloat(assessmentStat.termData)
                          ? assessmentStat.termData + "%"
                          : "0%"
                      }
                      icon={<FaChartLine className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Term Attendance"
                      entry="N/A"
                      icon={<FaChartArea className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
              </div>

              <div className="top_stat_box mb-20">
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Session Assessment"
                      entry={
                        !empty(assessmentStat) &&
                        !empty(assessmentStat.sessionData) &&
                        parseFloat(assessmentStat.sessionData)
                          ? assessmentStat.sessionData + "%"
                          : "0%"
                      }
                      icon={<FaBookReader className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Current Class Rating"
                      entry={studentCurrentAssessmentRating}
                      icon={<FaChartLine className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
              </div>

              <MainHeader title="Finance Stat" />
              <div className="top_stat_box mt-10">
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Total Fee(s)"
                      entry={schoolCurrency + " " + fees}
                      icon={<FaMoneyBill className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Fee(s) Paid"
                      entry={schoolCurrency + " " + totalFeesPaid}
                      icon={<FaMoneyCheck className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Balance Owed"
                      entry={schoolCurrency + " " + balanceOwed}
                      icon={<FaMoneyBillWaveAlt className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Arrears"
                      entry={schoolCurrency + " " + balanceOwed}
                      icon={<FaRegMoneyBillAlt className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}

              {/* chart */}
              <div className="chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Current Session-Term Performance" />
                      <CompoundBarChart data={chartData} />
                    </>
                  }
                  addStyle="barchart"
                />
              </div>
              {/* end chart */}

              {/* assigned subjects and classes */}
              <div className="flex col-g-12" style={{ width: "98%" }}>
                <Card
                  children={
                    <>
                      <MainHeader title="Term Performances" />
                      <div className="mt-10">
                        {!empty(studentReports) && isArray(studentReports) ? (
                          studentReports.map((item, index) => {
                            const position =
                              !empty(item) && !empty(item.position)
                                ? item.position
                                : "---";
                            const average =
                              !empty(item) && !empty(item.average)
                                ? item.average
                                : "---";
                            const termTitle =
                              !empty(item) && !empty(item.termTitle)
                                ? item.termTitle
                                : "---";
                            const sessionTitle =
                              !empty(item) && !empty(item.sessionTitle)
                                ? item.sessionTitle
                                : "---";

                            return (
                              <div
                                key={index}
                                className="mb-10 flex direction-column bio-data-item"
                              >
                                <span style={{ color: colors.primary }}>
                                  <FaStar
                                    style={{
                                      marginRight: 8,
                                      fontSize: 12,
                                    }}
                                    color="#DAA520"
                                  />
                                  {sessionTitle}:
                                </span>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    marginTop: 5,
                                    fontSize: 14,
                                  }}
                                >
                                  <ul className="ml-5">
                                    <li className="mb-5">
                                      <strong>Term Title: </strong>
                                      {termTitle}
                                    </li>
                                    <li className="mb-5">
                                      <strong>Average: </strong>
                                      {average + "%"}
                                    </li>
                                    <li className="mb-5">
                                      <strong>Position: </strong>
                                      {position}
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <EmptyList />
                        )}
                      </div>
                    </>
                  }
                  addStyle="dashboard-aassigned-items"
                />
                <Card
                  children={
                    <>
                      <MainHeader title="Fee Transactions History" />
                      <div className="mt-10">
                        {!empty(subjectsOffered) && isArray(subjectsOffered) ? (
                          subjectsOffered.map((item) => {
                            return (
                              <p
                                key={
                                  !empty(item) && !empty(item._id)
                                    ? item._id
                                    : 0
                                }
                                className="mb-10 flex space-between bio-data-item"
                              >
                                <span>
                                  <FaStar
                                    style={{
                                      marginRight: 8,
                                      fontSize: 12,
                                    }}
                                    color="#DAA520"
                                  />
                                  {!empty(item) && !empty(item.title) ? (
                                    <NavLink
                                      style={{
                                        textDecoration: "none",
                                        color: "#633ccd",
                                      }}
                                      to={`/classes/${
                                        !empty(item) && !empty(item._id)
                                          ? item._id + "/profile"
                                          : ""
                                      }`}
                                    >
                                      {item.title}
                                    </NavLink>
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </p>
                            );
                          })
                        ) : (
                          <EmptyList />
                        )}
                      </div>
                    </>
                  }
                  addStyle="dashboard-aassigned-items"
                />
              </div>
              {/* end of assigned subjects and classes */}
            </div>
            {/* end of left box */}

            {/* right box */}
            <div id="main_right_box">
              {/* calendar */}
              <Card
                children={
                  <AppCalendar
                    onChange={onChange}
                    value={value}
                    onClickDay={(value) => alert(value)}
                  />
                }
                addStyle="card_adjust"
              />

              {/* end of calendar */}
              <div className="main_right_boxes">
                {/* activities */}
                <Card
                  children={
                    <>
                      <MainHeader
                        title="Activities"
                        buttonHeight={25}
                        textSize={12}
                      />
                      <EmptyList />
                    </>
                  }
                  addStyle="card_adjust"
                />
                {/* end of activities */}
              </div>
            </div>
          </div>
          {/* end of right box */}
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </AppWrapper>
    </>
  );
};

export default Dashboard;
